import React from 'react'
import StaticPage from '../components/StaticPage'

function AboutPage() {
  return (
    <StaticPage title="About Wingbeat" intro="A small, friendly club in the Scottish Borders">
      <p>
        Wingbeat is perhaps one of the smallest paragliding clubs in the UK, based around the
        tributaries of the River Tweed in the Teviot, Ettrick and Yarrow Valleys of the Southern
        Uplands. The club started in the 1990s, originating from the local paragliding school run by
        Joe and Lyn Campion. When Joe left the Borders, the original members retained the name for
        the club.
      </p>
      <p>
        Wingbeat may be the only club in the UK to have almost more sites than members, reflecting
        the remoteness of the Borders and the excellent relationship we have with local farmers and
        landowners. It is not unknown for the club to be approached by farmers asking if we can fly
        their hill.
      </p>
      <p>
        Unlike most clubs we do not have a constitution or committee; we are just a group of folk
        with a common love of paragliding and the outdoors. Current members are drawn from the
        Borders, Dumfries and Galloway, Central Scotland and Ayrshire. You do not have to be Scottish
        to join, though an understanding of the local dialect helps you join in the craic on the hill.
      </p>
      <p>
        Wingbeat offers everyone a warm welcome to the Borders, so why not{' '}
        <a href="/contact">get in touch</a> if you would like to fly in this part of Scotland.
      </p>
      <p className="muted">Fly safe - the Wingbeat team.</p>
    </StaticPage>
  )
}

export default AboutPage
